module.exports = __webpack_public_path__ + "static/img/brees-2017-top.3c5ac27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-top.jpg
// module id = 2SXg
// module chunks = 1